// fixed_header, phones: the header (breadcrumb bar and corner controls) and the
// bottom chrome (navbar, New button, the bottom editor pill with its chip and
// close control) slide out of view as the reader scrolls down and back as they
// scroll up. The slide follows the scroll itself, so it can be pushed back and
// forth mid-way; once scrolling stops it settles fully in or out.
//
// The progress (0 shown … 1 hidden) is written as --chrome-p on each moving
// element only, never on <html>: a custom property on the root restyles the
// whole page. <html data-mobile-chrome="hidden"> marks the settled hidden
// state for listeners such as the media dock.

export const MOBILE_CHROME_ATTR = 'mobileChrome'
export const CHROME_PROGRESS_VAR = '--chrome-p'
export const CHROME_SETTLING_ATTR = 'data-chrome-settling'
// Near the top the chrome always shows.
export const MOBILE_CHROME_TOP_ZONE_PX = 46
// Scroll travel that takes the chrome from fully shown to fully hidden.
export const MOBILE_CHROME_RANGE_PX = 96
// Quiet time after the last scroll before the chrome settles.
export const MOBILE_CHROME_SETTLE_DELAY_MS = 140
// How long the header comes back to name a thread whose head post has just
// scrolled away under a hidden header, before it slides off again.
export const MOBILE_CHROME_PEEK_MS = 2500

export function nextChromeOffset(
    offset: number,
    delta: number,
    scrollTop: number,
    range = MOBILE_CHROME_RANGE_PX,
): number {
    if (scrollTop <= MOBILE_CHROME_TOP_ZONE_PX) return 0
    return Math.min(range, Math.max(0, offset + delta))
}

// Where a part-way slide comes to rest: whichever end it is nearer.
export function settleChromeOffset(offset: number, range = MOBILE_CHROME_RANGE_PX): number {
    return offset >= range / 2 ? range : 0
}

export function writeChromeProgress(
    elements: Array<HTMLElement | null | undefined>,
    progress: number,
    settling: boolean,
) {
    const value = String(Math.round(Math.min(1, Math.max(0, progress)) * 1000) / 1000)
    elements.forEach(el => {
        if (!el) return
        el.style.setProperty(CHROME_PROGRESS_VAR, value)
        el.toggleAttribute(CHROME_SETTLING_ATTR, settling)
    })
}

export function setMobileChromeHidden(hidden: boolean) {
    if (typeof document === 'undefined') return
    const root = document.documentElement
    if (hidden) {
        if (root.dataset[MOBILE_CHROME_ATTR] !== 'hidden')
            root.dataset[MOBILE_CHROME_ATTR] = 'hidden'
    } else if (root.dataset[MOBILE_CHROME_ATTR]) delete root.dataset[MOBILE_CHROME_ATTR]
}

export function isMobileChromeHidden(): boolean {
    if (typeof document === 'undefined') return false
    return document.documentElement.dataset[MOBILE_CHROME_ATTR] === 'hidden'
}
